import { VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'

export function NewsInternalEstabilizacaoV53() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.3.33' id='estabilizacao-5-3-33'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Atualização das regras para o registro da aplicação do imunobiológico Vacina Sarampo, Rubéola.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.32' id='estabilizacao-5-3-32'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Inclusão de filtros relacionados ao instrumento de TRIA para identificar os cidadãos em risco de insegurança
            alimentar e aqueles que não tiveram o instrumento aplicado no módulo de Acompanhamento de condições de
            saúde.
          </NewsListItem>
          <NewsListItem>
            Foi realizado um ajuste para evitar que, ao iniciar o atendimento, a mensagem "Uma avaliação automática foi
            alterada na lista de problemas e/ou condições avaliados" apareça repetidamente na tela.
          </NewsListItem>
          <NewsListItem>
            Inclusão do novo grupo de exames "Dengue" na solicitação de exames, com inclusão dos seguintes
            procedimentos: Hemograma completo, Pesquisa de anticorpos IgM contra arbovírus, Pesquisa de anticorpos IgG
            contra arbovirus, Teste rápido para dengue IgG/IgM e Isolamento do vírus da dengue.
          </NewsListItem>
          <NewsListItem>
            Atualização da mensagem indicativa de cidadão sem CNS cadastrado no módulo de Agenda caso a instalação
            esteja utilizando o serviço de agendamento online.
          </NewsListItem>
          <NewsListItem>
            Atualização das regras para o registro da aplicação do imunobiológico COVID-19 RNAm, Moderna (Spikevax), bem
            como a atualização e inclusão de fabricantes.
          </NewsListItem>
          <NewsListItem>
            Ajuste no comportamento do ícone de lupa para visitas domiciliares e territoriais com atendimento "Visita
            recusada" ou "Cidadão ausente" no histórico da Folha de rosto.
          </NewsListItem>
          <NewsListItem>
            Estruturado o resultado do exame Prova do Laço com as opções qualitativas: Positivo, Negativo e
            Inconclusivo.
          </NewsListItem>
          <NewsListItem>
            Correção no filtro de CBO da lista de cuidado compartilhado, que agora permite listar corretamente todas as
            CBOs dos profissionais solicitantes e executantes, sem exibir a mensagem de erro "Acesso não permitido".
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde, em alguns casos, um alerta de erro era mostrado incorretamente ao tentar adicionar
            um novo cidadão à família de um imóvel no módulo de Acompanhamento de território.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.31' id='estabilizacao-5-3-31'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>Melhoria no processo de busca de cidadãos na agenda.</NewsListItem>
          <NewsListItem>
            Atualização de regras para registro de aplicação dos imunobiológicos Covid-19-inativada, Sinopharm e Vacina
            influenza trivalente.
          </NewsListItem>
          <NewsListItem>
            Remoção da possibilidade de selecionar uma equipe responsável pelo cidadão que não seja a informada no
            Cadastro individual mais recente.
          </NewsListItem>
          <NewsListItem>
            Correções e melhorias visando performance durante a etapa de processamento de famílias nos relatórios.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.30' id='estabilizacao-5-3-30'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Inclusão da opção "TEA", referente ao Transtorno do Espectro Autista, como uma das opções de deficiência
            referida na Ficha de cadastro individual.
          </NewsListItem>
          <NewsListItem>
            Foi tornado obrigatório o preenchimento do campo "Está em situação de rua?" no Cadastro individual do CDS e
            no recebimento de MICI de sistemas próprios.
          </NewsListItem>
          <NewsListItem>
            Atualização de regras para registro de aplicação dos imunobiológicos Vacina pneumo 13, Vacina Varíola
            Bavarian Nordic e Influenza trivalente.
          </NewsListItem>
          <NewsListItem>
            Foi realizada uma refatoração do processo de criação de fichas automáticas e alertas de erros de validação
            para o usuário, corrigindo assim, problemas reportados por diversos chamados de suporte que acusavam erro do
            sistema ao atualizar registros antigos, via Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que o comunicado de hanseníase não estava sendo exibido corretamente no cartão de
            doses aplicadas da vacina BCG.
          </NewsListItem>
          <NewsListItem>
            Correção no nome do arquivo da impressão dos agendamentos de um cidadão para utilizar o nome social do
            cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção do comportamento ao salvar lotação de estágio: removido componente de cancelamento indevido e
            ajustado para exibir apenas alerta de confirmação, com redirecionamento automático para o perfil do
            profissional.
          </NewsListItem>
          <NewsListItem>
            Correção no módulo de Garantia de acesso para permitir a remoção correta de cidadãos da lista após
            unificação de cadastros.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.29' id='estabilizacao-5-3-29'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção na formatação da reimpressão da prescrição de medicamentos, garantindo a exibição correta das doses
            fracionadas por turno.
          </NewsListItem>
          <NewsListItem>
            Correção na exibição do status de vacinação no PEC, garantindo que registros feitos via ficha CDS apareçam
            corretamente como "Aplicado".
          </NewsListItem>
          <NewsListItem>
            Ajustes de visualização na exibição de Lotes e Fabricantes, garantindo que os dados não fiquem sobrepostos
            ao cadastrar nomes longos e sem espaços para os imunobiológicos.
          </NewsListItem>
          <NewsListItem>
            Corrigido o erro que ocorria ao obter dados do CBO associado à última atualização de um cidadão do imóvel,
            lançando uma mensagem de erro durante a atualização do cadastro deste imóvel.
          </NewsListItem>
          <NewsListItem>
            Ajuste no módulo de profissionais para exibir uma identificação nas lotações cadastradas manualmente.
          </NewsListItem>
          <NewsListItem>
            Otimização da Garantia de acesso por meio da adaptação do formulário de inclusão de cidadãos na listagem
            para um modelo mais compacto.
          </NewsListItem>
          <NewsListItem>
            Atualização de regras para registro de aplicação do imunobiológico Influenza trivalente.
          </NewsListItem>
          <NewsListItem>
            Atualização no módulo de Serviços de referência para considerar apenas o tipo da unidade no CNES para
            definir se ele é referência ou receptora.
          </NewsListItem>
          <NewsListItem>
            Criação do novo tipo de serviço padrão "Arboviroses", disponível para unidades UBS e UPA.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.28' id='estabilizacao-5-3-28'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção na lógica da TRIA para avaliação de risco de insegurança alimentar. Agora, a regra considera a
            idade do cidadão na data de preenchimento da Ficha de cadastro individual (FCI), garantindo que apenas
            fichas preenchidas por cidadãos com 18 anos ou mais sejam utilizadas na verificação.
          </NewsListItem>
          <NewsListItem>
            Implementação de nova opção de motivo de visita, chamado "Pessoa idosa", no modelo de informação de Visita
            domiciliar territorial.
          </NewsListItem>
          <NewsListItem>
            Adicionada a opção de criar tipos de serviços exclusivos para unidades do tipo UPA e Policlínicas.
          </NewsListItem>
          <NewsListItem>
            Atualização para incluir o CBO 2234-05 (Farmacêutico) como possibilidade de compartilhamento de cuidado para
            eMulti, conforme a Portaria GM/MS Nº 6.010, de 10 de dezembro de 2024.
          </NewsListItem>
          <NewsListItem>
            Ajuste na exibição do texto no campo Anotações do histórico clínico da Folha de rosto para atendimento de
            Visita domiciliar e territorial realizado pelo aplicativo.
          </NewsListItem>
          <NewsListItem>
            Atualização de regras para registro de aplicação do imunobiológico Vacina influenza trivalente, incluindo a
            estratégia "Rotina", inativação das doses D1 e D2 da estratégia "Especial" e atualização das regras das
            doses relacionadas às estratégias "Especial", "Campanha indiscriminada" e "Vacinação escolar".
          </NewsListItem>
          <NewsListItem>
            Corrigido erro no processamento de relatórios na etapa "Limpeza dos dados antigos" que acontecia em algumas
            instalações.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que um imunobiológico contra a Covid-19 estava sendo exibido no calendário vacinal da
            Busca ativa de vacinação.
          </NewsListItem>
          <NewsListItem>
            Foi removida a possibilidade de preencher o campo "Raça/Cor" com a opção "sem informação".
          </NewsListItem>
          <NewsListItem>
            Implementação de sinalização visual (em formato de tag) nos imóveis que possuam inconsistência e
            possibilidade de filtrar imóveis com inconsistências, no Acompanhamento do território.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.27' id='estabilizacao-5-3-27'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Ajuste na validação de data de nascimento ao registrar um marcador de consumo alimentar em um atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção da mensagem de dica apresentada no módulo de agenda para usuários que não possuem o recurso
            "Agendar".
          </NewsListItem>
          <NewsListItem>
            Correção no histórico da discussão de caso, que não exibia a palavra "Motivo" ao registrar a troca do
            profissional de referência no Cuidado compartilhado.
          </NewsListItem>
          <NewsListItem>
            Correção na impressão da Ficha de notificação de caso suspeito no atendimento, que não exibia o nome social
            do cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde os termos relacionados aos medicamentos Isotretinoína, Tretinoína ou Acitretina
            eram gerados com duplicidade ao realizar a impressão.
          </NewsListItem>
          <NewsListItem>
            Ao atualizar um responsável familiar através do módulo de Acompanhamento do território e informar um CPF
            para ele, também será criada uma Ficha de cadastro individual automática para este cidadão.
          </NewsListItem>
          <NewsListItem>
            Disponibilização da impressão da visita domiciliar gerada no aplicativo e-SUS Território através do
            histórico do cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção do cenário em que não era possível atualizar o cadastro de um imóvel no cenário em que mais de um
            registro era encontrado para o imóvel.
          </NewsListItem>
          <NewsListItem>
            Correção de problema na impressão do histórico de atendimento domiciliar pelo aplicativo e-SUS AD,
            garantindo que as informações sejam exibidas corretamente nos relatórios.
          </NewsListItem>
          <NewsListItem>
            Correções gerais de erros de envio de imunobiológicos RIA-C e RIA-Carga para a RNDS.
          </NewsListItem>
          <NewsListItem>
            Inclusão da indicação "15 meses" no cartão da dose de reforço do imunobiológico VIP (Vacina polio
            injetável).
          </NewsListItem>
          <NewsListItem>
            Atualização de regras para registro de aplicação dos imunobiológicos HEXA, incluindo a estratégia de Rotina
            e atualizada a regra da estratégia Especial da dose R1.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.26' id='estabilizacao-5-3-26'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Agora, a Busca ativa de vacinação considera as doses de reforço (REF) do imunobiológico VIP como
            equivalentes às doses R1 e R2 do imunobiológico VOP, caso estas já tenham sido aplicadas.
          </NewsListItem>
          <NewsListItem>
            Informações de resultados de exames estruturados registrados em Atendimentos odontológicos importados no PEC
            passarão a ser exibidas no Histórico clínico do cidadão.
          </NewsListItem>
          <NewsListItem>
            Ajuste no tamanho do texto apresentado na tabela de prescrições digitais para evitar quebra de layout.
          </NewsListItem>
          <NewsListItem>
            Inclusão de tratamento de nome social do cidadão nos termos de consentimento gerados na prescrição de
            medicamentos.
          </NewsListItem>
          <NewsListItem>
            Com a implementação das equivalências dos imunobiológicos VIP e VOP na Busca ativa de vacinação, foi
            removida a mensagem relacionada à dose de reforço (REF) do imunobiológico VIP, que estava sendo sinalizada
            como atrasada, mesmo com as doses R1 e R2 do imunobiológico VOP aplicadas.
          </NewsListItem>
          <NewsListItem>
            Correção no modal de "Agendar consulta" do módulo de Garantia do acesso para exibir as lotações
            profissionais corretamente.
          </NewsListItem>
          <NewsListItem>
            Correção nas impressões de agendamento entre profissionais sem o cidadão, onde o nome do profissional
            convidado não era apresentado.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde durante a importação de determinadas CIAPs estavam apresentando erro quando
            preenchidas nos campos "OutroCIAP".
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde o sistema impedia a evolução de um problema/condição no SOAP em cidadãos
            unificados.
          </NewsListItem>
          <NewsListItem>
            Correção de erro que fazia o botão de impressão do acompanhamento de cidadãos vinculados e da busca ativa
            desaparecer.
          </NewsListItem>
          <NewsListItem>
            Correção de problema em que, ao preencher um campo de texto no SOAP, retirar o foco e incluir novamente, as
            opções de desfazer e refazer digitação não funcionavam corretamente.
          </NewsListItem>
          <NewsListItem>Correção de problema que impedia a criação de novos perfis customizados.</NewsListItem>
          <NewsListItem>
            Correção de erro que impedia o profissional de finalizar o atendimento de observação e mostrava o campo
            "Intervenções e/ou procedimentos clínicos realizados" como pendente.
          </NewsListItem>
          <NewsListItem>
            Correção de erro que impedia o profissional de finalizar um atendimento de observação ao duplicar um
            CID10/CIAP2.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a unidade de fornecimento era substituída pela unidade de medida na reimpressão
            de medicamentos.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a quantidade total receitada não estava sendo exibida nos termos de
            responsabilidade ao reimprimir os medicamentos.
          </NewsListItem>
          <NewsListItem>
            Correção aplicada no campo número de moradores que estava gerando impacto nos critérios de completude do
            cadastro no módulo de Acompanhamento de território.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.25' id='estabilizacao-5-3-25'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            A partir desta versão, medidas de peso informadas na Puericultura também passam a ser consideradas para
            exibição na modal de Prescrição de Medicamentos, caso sejam mais recentes.
          </NewsListItem>
          <NewsListItem>
            Foi implementada a nova estratégia de "Vacinação escolar" assim como suas respectivas regras de aplicação
            para mais de 20 imunobiológicos (HepB, VFA, BCG, VPP23, VIP, SCR, dT, VPC10, INF3, VAR, MenC, PENTA, ROTA,
            DTP, HepAinf, SCRV, dTpa, VPC13, MenACWY, Moderna-Spikevax, Pfizer para menores de 5 anos e DNG).
          </NewsListItem>
          <NewsListItem>
            Foram incluídos no sistema os procedimentos pertencentes ao subgrupo 04 - Telessaúde e atualizados os
            procedimentos do grupo 09 - Procedimentos para Ofertas de Cuidados Integrados.
          </NewsListItem>
          <NewsListItem>
            Correção de um problema no qual, ao evoluir um cuidado compartilhado, o histórico de atendimentos
            relacionados não era exibido corretamente.
          </NewsListItem>
          <NewsListItem>
            Ajuste de cenário que impedia a atualização do sistema e a unificação de bases devido a um valor nulo nos
            registros de problemas/condições.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário que impedia a finalização do atendimento caso dois problemas/condições possuíssem a
            mesma data e hora de fim.
          </NewsListItem>
          <NewsListItem>
            Ajuste de erro onde havia divergência no número de aplicações e na data nos cartões das doses aplicadas no
            histórico do atendimento de vacinação.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde era possível realizar dois agendamentos ao mesmo tempo e no mesmo horário para um
            mesmo profissional.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.24' id='estabilizacao-5-3-24'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de erro onde, após a atualização do sistema, alguns campos referentes ao CID10 não eram carregados.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.23' id='estabilizacao-5-3-23'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>Correção de cenário onde o profissional fixava-se em sua própria agenda.</NewsListItem>
          <NewsListItem>
            Atualizadas as regras de aprazamento e faixa etária para os imunobiológicos Vacina rotavírus (ROTA) e Vacina
            sarampo, caxumba, rubéola (SCR).
          </NewsListItem>
          <NewsListItem>
            Correção da validação do campo "número de moradores" no domicílio, que impedia que imóveis sem moradores
            ficassem com o cadastro completo.
          </NewsListItem>
          <NewsListItem>
            Correção de erro onde não estava sendo possível utilizar o link de redefinição de senha em instalações que
            não possuíam o SMTP configurado.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que ocorria erro ao realizar a impressão de um medicamento na Prescrição de
            medicamentos.
          </NewsListItem>
          <NewsListItem>
            Ajuste na mensagem apresentada para o usuário quando uma vacina era retificada enquanto o servidor da RNDS
            não estivesse funcionando.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde um erro era apresentado ao realizar a reimpressão de medicamentos via Folha de
            rosto.
          </NewsListItem>
          <NewsListItem>
            Correção da importação de fichas de Atendimento individual para cenários em que a ficha possua a lista de
            encaminhamentos vazia.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.22' id='estabilizacao-5-3-22'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Ao adicionar uma medição anterior através do cartão lateral do SOAP, o peso mais recente do cidadão será
            considerado na modal de Prescrição de medicamentos.
          </NewsListItem>
          <NewsListItem>
            Inclusão de uma nova regra para o novo termo de responsabilidade/esclarecimento da Prescrição de
            medicamentos, passando a contemplar as opções de identidade de gênero e sexo indeterminado.
          </NewsListItem>
          <NewsListItem>
            Inclusão de novos Grupos de atendimentos disponíveis para seleção ao registrar aplicação de imunobiológico.
          </NewsListItem>
          <NewsListItem>
            Inclusão de novo imunobiológico COVID-19 SERUM/ZALIKA e atualização de diversas regras de aplicação para
            outros imunobiológicos contra COVID-19.
          </NewsListItem>
          <NewsListItem>
            Correção do cenário em que ocorria chave duplicada em relação aos problemas e condições recebidos de bases
            unificadas ao tentar finalizar um atendimento.
          </NewsListItem>
          <NewsListItem>
            Inclusão dos campos de localização e código do domicílio na tabela de acompanhamento dos cidadãos
            vinculados.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que os campos de data inicial e final, CID e CIAP dos atendimentos não estavam sendo
            processados corretamente, impactando relatórios e o histórico de atendimentos.
          </NewsListItem>
          <NewsListItem>
            Ajustes no módulo de importação de CNES, onde, em algumas instalações, não estava sendo possível importar o
            arquivo.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde uma página em branco era gerada ao imprimir medicamentos com preenchimento manual.
          </NewsListItem>
          <NewsListItem>Correção de erro que impedia a atualização do sistema em algumas instalações.</NewsListItem>
          <NewsListItem>
            Ajuste no campo Desfecho da escuta inicial para manter a opção "Adicionar cidadão na lista de atendimentos"
            como padrão já pré-selecionado ao finalizar a escuta.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde algumas famílias estavam sendo duplicadas ao se atualizar as Fichas de cadastro
            domiciliar e territoriais correspondentes a elas.
          </NewsListItem>
          <NewsListItem>
            Correção na filtragem do campo "Problemas / Condições avaliadas - Outros CIAP 2" no módulo de Relatório de
            atendimento individual.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.21' id='estabilizacao-5-3-21'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de erro relacionado ao motivo do desfecho no envio de registros para RNDS.
          </NewsListItem>
          <NewsListItem>Correção de cenário que impedia a atualização do sistema em algumas instalações.</NewsListItem>
          <NewsListItem>
            Adicionada a possibilidade de ver as doses fracionadas de medicamentos por turno no Histórico clínico do
            cidadão de Atendimentos odontológicos.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que cidadãos sem informações de doses eram exibidos incorretamente na listagem da
            Busca Ativa de Vacinação.
          </NewsListItem>
          <NewsListItem>
            Adicionada mensagem informativa na Busca ativa de vacinação, onde as doses de reforço (REF) do
            imunobiológico VIP serão exibidas como atrasadas, mesmo que as doses R1 e R2 do imunobiológico VOP já tenham
            sido aplicadas.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.20' id='estabilizacao-5-3-20'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>Atualização da tela de links úteis e inclusão do link do Educa e-SUS APS.</NewsListItem>
          <NewsListItem>
            Implementada a funcionalidade de reimpressão de receitas médicas no cartão de Medicamentos, disponível na
            Folha de rosto e no Atendimento.
          </NewsListItem>
          <NewsListItem>
            Inclusão do novo termo de responsabilidade na Prescrição de medicamentos com Talidomida, para cidadãos do
            sexo feminino e menores de 55 anos.
          </NewsListItem>
          <NewsListItem>
            Retirada do campo subjetivo enviado para a RNDS no Registro de atendimento clínico.
          </NewsListItem>
          <NewsListItem>
            Atualização para melhorar a performance dos relatórios gerenciais quando o banco de dados RocksDB está
            habilitado na instalação.
          </NewsListItem>
          <NewsListItem>
            Alteração da terminologia "Idoso" ou "Idosos" para "Pessoa idosa" ou "Pessoas idosas" respectivamente.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde o uso de nome social do profissional não era aplicado em alguns agendamentos
            futuros.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.3.19' id='estabilizacao-5-3-19'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Atualizações globais no sistema para assegurar compatibilidade com a nova opção de sexo "Indeterminado".
          </NewsListItem>
          <NewsListItem>
            Agora é possível visualizar doses fracionadas de medicamentos por turno no histórico clínico do cidadão para
            atendimentos individuais.
          </NewsListItem>
          <NewsListItem>
            Ajustes no histórico clínico para exibir corretamente o nome social dos profissionais.
          </NewsListItem>
          <NewsListItem>
            Correção no campo de modalidade assistencial transmitido para a RNDS no Registro de Atendimento Clínico.
          </NewsListItem>
          <NewsListItem>Inclusão de um link para a página de "Links Úteis" na tela inicial do sistema.</NewsListItem>
          <NewsListItem>
            Implementação de restrição para impedir a seleção da opção "Manter cidadão na lista de atendimento" em
            registros de atendimentos realizados em datas anteriores.
          </NewsListItem>
          <NewsListItem>Inclusão do peso do cidadão na modal de prescrição de medicamentos.</NewsListItem>
          <NewsListItem>
            Adição de alerta para informar sobre alergias recentemente registradas, garantindo que o profissional
            visualize avisos de alergia durante o atendimento.
          </NewsListItem>
          <NewsListItem>
            As quebras de linha inseridas no campo de recomendações agora são exibidas corretamente na impressão das
            prescrições de medicamentos.
          </NewsListItem>
          <NewsListItem>
            Atualização das regras para registro da aplicação das vacinas VIP (código 22), dT (código 25), VOP (código
            28) e dTpa (código 57), com os ajustes necessários no calendário vacinal infantil.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
